// extracted by mini-css-extract-plugin
export default {"wrapper":"AdjustmentsTabContent_wrapper__9RxLQ","resetButton":"AdjustmentsTabContent_resetButton__AE7Kz"};